"use client";

import { BookOpen, Users, Video } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AcademicTutoringCoreService() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const formats = [{
    icon: BookOpen,
    title: "Curriculum-Aligned Group Placement",
    description: "Personalised learning tailored to your pace, goals and exam board."
  }, {
    icon: Users,
    title: "Small Group Classes",
    description: "Collaborative learning with peers in focused study groups."
  }, {
    icon: Video,
    title: "Online Tutoring",
    description: "Live, flexible remote sessions with expert tutors anywhere, recorded for playback later if needed. (Recording without student faces)"
  }];
  return <section className="bg-light-background py-16 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={leftRef} className="flex flex-col justify-center">
            <h2 className={`font-display text-4xl font-bold text-foreground-light lg:text-5xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "animate-fade-in-up" : "opacity-0 translate-y-4"}`}>
              Academic Tutoring – Core Service
            </h2>
            <p className={`mt-6 text-lg text-muted-foreground leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "animate-fade-in-up-delay-100" : "opacity-0 translate-y-4"}`}>Our expert tutors provide comprehensive academic support across a wide range of subjects, helping students excel at every level.&nbsp; The sessions are delivered primarily through small, structured group sessions.</p>
          </div>

          {}
          <div ref={rightRef} className="flex flex-col justify-center">
            <div className="space-y-6">
              {formats.map((format, i) => {
              const Icon = format.icon;
              return <div key={i} data-index={i} className={`flex items-start gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${rightVisible ? "animate-fade-in-up opacity-100" : "opacity-0 translate-y-4"}`} style={{
                animationDelay: `${i * 100}ms`
              }}>
                    <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-secondary transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110">
                      <Icon className="size-6 text-foreground-secondary" />
                    </div>
                    <div>
                      <h3 className="font-display text-xl font-semibold text-foreground-light">
                        {format.title}
                      </h3>
                      <p className="mt-2 text-muted-foreground leading-relaxed">
                        {format.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            <div className={`mt-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${rightVisible ? "animate-fade-in-up-delay-200" : "opacity-0 -translate-x-4"}`}>
              <Link to="/SubjectsPage" className="inline-flex items-center gap-2 text-lg font-semibold text-primary underline-offset-4 transition-all duration-[var(--duration-fast)] hover:underline hover:text-primary-hover">
                Browse subjects
                <span className="transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1">→</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}